import React, { Fragment, FunctionComponent, useState } from 'react';
import classNames from '../../../utils/classnames';
import InfoIcon from '../../../icons/components/Info';

export const InputHolder: FunctionComponent<{ isCentered?: boolean, isFlexWrap?: boolean, tooltip?: string }> = ({
    children,
    isCentered,
		isFlexWrap,
		tooltip
}) => {
    const classes = classNames('c-input-holder', {
        'input-holder--centered': isCentered,
				'input-holder--flex-wrap': isFlexWrap || tooltip,
    });
		const [showToolTip, setShowToolTip] = useState(false);

    return <div className={classes}>
			{children}
			{tooltip && (
				<Fragment>
					<span className={`input-holder__tool-tip-icon`}>
						<p onClick={() => setShowToolTip(!showToolTip)}><InfoIcon width={30} height={32} /></p>
					</span>
				</Fragment>
			)}
			{showToolTip && tooltip && (
				<div className="input-holder__tool-tip-content" dangerouslySetInnerHTML={{__html: tooltip}}></div>
			)}

		</div>;
};

export const InputHolderItem: FunctionComponent<{ isSmall?: boolean, isFullWidth?: boolean, isFlexBasis?:boolean }> = ({
    children,
    isSmall,
		isFullWidth,
		isFlexBasis,
}) => {
    return (
        <div className={`input-holder__item ${isFullWidth ? 'input-holder__item--full-width' : ''} ${isSmall ? 'input-holder__item--small' : ''} ${isFlexBasis ? 'input-holder__item--flex-basis' : ''}`}>
            {children}
        </div>
    );
};
